import { defineStore } from "pinia";

export const useTaskModelStore = defineStore('taskModel', {
  state: () => ({
    taskModel: {},
    taskModels: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setTaskModel(taskModel) {
      this.taskModel = taskModel
    },
    setTaskModels(taskModels) {
      this.taskModels = taskModels
    },
    addTaskModel(taskModel) {
      this.taskModels.unshift(taskModel)
    },
    updateTaskModel(taskModel) {
      let index = this.taskModels.findIndex(cl => cl.id === taskModel.id)
      this.taskModels.splice(index, 1, taskModel)
    },
    deleteTaskModel(taskModel) {
      let index = this.taskModels.findIndex(cl => cl.id === taskModel.id)
      this.taskModels.splice(index, 1)
    },
  },
});